import React from "react";
import classNames from "classnames";
import { useCreateProjectStrategicAxis } from "@planzone/view-models";
import { SelectList } from "@common/selectList";
import { Props } from "./types";
import { StrategicAxisCode } from "./tag";
import { ArrowIcon } from "./arrowIcon";
import { ScoreTag } from "./scoreTag";
import styles from "./styles.scss";

function ProjectStrategicAxisCreation({ strategicAxis, project }: Props) {
  const { createProjectStrategicAxis } = useCreateProjectStrategicAxis();

  return (
    <div className={styles.projectStrategicAxisCreation}>
      <div className={styles.cell}>
        <StrategicAxisCode
          code={strategicAxis.code}
          color={strategicAxis.color}
        />
      </div>
      <p className={styles.cell}>{strategicAxis.name}</p>
      <p className={styles.weight}>{strategicAxis.weight}</p>
      <p className={styles.operator} />
      <div className={styles.cell}>
        <SelectList
          rootClassName={styles.consistencyValueSelection}
          listClassName={styles.listRoot}
        >
          {({ isOpen, select }) => ({
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.openedInput]: isOpen,
                })}
              >
                <div className={styles.inputText}>
                  <div>0</div>
                  {"0" !== strategicAxis.adequacyPossibilities["0"] && (
                    <div>{strategicAxis.adequacyPossibilities["0"]}</div>
                  )}
                </div>
                {isOpen ? (
                  <div>
                    <ArrowIcon className={styles.iconOpen} />
                  </div>
                ) : (
                  <ArrowIcon className={styles.iconClose} />
                )}
              </div>
            ),
            list: (
              <div className={styles.list}>
                {Object.keys(strategicAxis.adequacyPossibilities)
                  .map((index) => Number(index))
                  .sort((current, next) => (current > next ? 1 : -1))
                  .map((index) => `${index}`)
                  .map((index, key) => (
                    <div
                      className={styles.role}
                      key={key}
                      onClick={() => {
                        select(index);
                        createProjectStrategicAxis({
                          project,
                          strategicAxis,
                          projectStrategicAxis: {
                            weight: strategicAxis.weight,
                            strategicAxisId: strategicAxis.uuid,
                            consistencyValue: Number(index),
                          },
                        });
                      }}
                    >
                      <div>{index}</div>
                      {index !== strategicAxis.adequacyPossibilities[index] && (
                        <div>{strategicAxis.adequacyPossibilities[index]}</div>
                      )}
                    </div>
                  ))}
              </div>
            ),
          })}
        </SelectList>
      </div>
      <div className={styles.operator} />
      <div>
        <ScoreTag value={0} />
      </div>
    </div>
  );
}

export { ProjectStrategicAxisCreation };
